import { render, staticRenderFns } from "./PatternJournalRightColumn.vue?vue&type=template&id=22653cf8"
import script from "./PatternJournalRightColumn.vue?vue&type=script&lang=js"
export * from "./PatternJournalRightColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports